module.exports = __webpack_public_path__ + "static/media/icon-social_media-facebook.f4407dc0.svg";